module.exports = function () {
    var $largeImage = $('.large-image');

    var adjustCaptionWidth = function () {
        $largeImage.each(function (index, el) {
            var $item = $(el);

            var $image = $item.find('.large-image-image');
            if ($image.length > 1) {
                if (ICF.Utils.Breakpoints.IsMobile()) {
                    $image = $item.find('.large-image-image--mobile');
                }
                else {
                    $image = $item.find('.large-image-image--desktop');
                }
            }
            
            var $description = $item.find('.large-image-description');

            if ($image.length && $description.length) {

                var imageItem = $image[0];

                if ((imageItem.complete && imageItem.naturalHeight !== 0) || ($image.data('lottieSrc') !== undefined)) {
                    var imageWidth = $image.width();

                    $description.css({
                        'width': imageWidth + 'px'
                    });
                }
                else {
                    $image.load(function () {
                        var imageWidth = $image.width();

                        $description.css({
                            'width': imageWidth + 'px'
                        });
                    });    
                }
            }
        });
    };

    if ($largeImage.length) {
        adjustCaptionWidth();

        $(window).resize(function() {
            requestAnimationFrame(adjustCaptionWidth);
        });
    }
};